var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var withCompInfo = function () {
    return function (depsArray, resolver) {
        var deps = depsArray.reduce(function (acc, key) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[key] = true, _a)));
        }, {});
        return {
            deps: deps,
            resolver: resolver,
        };
    };
};
export function createComponentMapperModel(mapper) {
    return mapper;
}
//# sourceMappingURL=createComponentMapper.js.map